import {Component, Vue} from 'vue-property-decorator'
import {
    getOutputRecordInfoById,
    getOutputTemplateList,
    sendOutput, sendOutputRecord,
    setOutputTemplate, updateOutputRecord
} from "@/api/classManage";
import commonData from "@/utils/commonData"
import E from "wangeditor";

@Component({})
export default class AddProduce extends Vue {
    formModel = {
        templateId: '',
        title: '',
        content: '',
        recipient: '',
        secret: '',
        attachmentList: [], // 附件
        isFinish: '',
        customerEmail: '', //收件人
        emailUser: '', //发件邮箱
    }
    formRules = {
        title: [{required: true, message: '请填写邮件主题', trigger: ['blur', 'change']}],
        templateId: [{required: true, message: '请选择模板', trigger: ['change']}],
        content: [{required: true, message: '请填写正文', trigger: ['blur', 'change']}],
        souCourseName: [{required: true, message: '请选择项目名称', trigger: ['blur', 'change']}],
        attachmentList: [{required: true, message: '请上传附件', trigger: 'change'}],
        isFinish: [{required: true, message: '请选择是否同步项目服务完成', trigger: 'change'}],
        customerEmail: [{required: true, message: '请填写收件人邮箱', trigger: 'change'}],
    }
    recordId = null //判断是否是编辑
    typeList = commonData.projectTypeArray
    // 开课时间
    isShow = null

    disabledBtn = false

    name = '' // 远程搜索name
    loading = false


    editor: any = null

    // templateList = [
    //     '模板一', '模板二', '模板三'
    // ]
    templatePage = '1'
    templateLimit = '20'
    classId = null
    financeOrderId = null
    outputTemplateList = [] // 模板列表
    dialogVisible = false
    isFinish = false
    dialogVisibletem = false
    timer = null
    fileCount = 0
    maxCount = 5
    total = 0
    created() {
        //  新建
        this.financeOrderId = this.$route.query.financeOrderId ? String(this.$route.query.financeOrderId) : null
        this.classId = this.$route.query.classId ? String(this.$route.query.classId) : null
        this.formModel.customerEmail = this.$route.query.email ? String(this.$route.query.email) : ''
        this.isFinish = this.$route.query.isFinish == 'true' ? true : false;
        if (this.isFinish == true) {
            this.formModel.isFinish = '0'
        }

        // 编辑
        this.recordId = this.$route.query.id
        if (!this.recordId) {
            this.getOutputTemplateList()
        } else {
            // 查详情
            this.getOutputRecordInfoById()
        }
    }

    get baseUrl() {
        let str = '/fileApi/upload/upload'
        if (process.env.NODE_ENV !== "development") {
            if (window.location.origin.includes('-testserver')) {
                str = process.env.VUE_APP_DEV_FILE_API + 'upload/upload'
            } else {
                str = process.env.VUE_APP_MASTER_FILE_API + 'upload/upload'
            }
        }
        return str
    }

    mounted() {
        this.initEditor()
    }

    /*初始化 默认家在论文模版*/
    getOutputTemplateList() {
        getOutputTemplateList({
            classesId: this.classId,
            financeOrderId: this.financeOrderId,
            page: this.templatePage,
            limit: this.templateLimit,
        }).then((res: any) => {
            this.outputTemplateList = res.outputTemplateList
            this.total = res.allNum
            if (this.outputTemplateList.length == 0) {
                this.dialogVisibletem = true
            }
            this.formModel.templateId = res.outputTemplateList[0].name
            /*默认模板1 ，可以更改*/
            this.formModel.recipient = res.outputTemplateList[0].ccStr
            this.formModel.secret = res.outputTemplateList[0].bccStr
            this.formModel.title = res.outputTemplateList[0].subjectStr
            this.formModel.emailUser = res.outputTemplateList[0].emailUser
            this.editor.txt.html(res.outputTemplateList[0].contentStr)
            this.formModel.customerEmail = res.customerEmail
        })
    }

    handleSizeChange(val) {
        this.templateLimit = val;
        this.getOutputTemplateList()
    }

    handleCurrentChange(val) {
        this.templatePage = val;
        this.getOutputTemplateList()
    }

    // 初始化富文本编辑器
    initEditor() {
        //   console.log(E)
        this.editor = new E('#editor-box')
        this.editor.config.height = 200
        this.editor.config.excludeMenus = [
            'fontName',
            'table',
            'code',
            'todo',
            'video',
            'audio',
        ]
        // this.editor.config.uploadImgServer = 'http://192.168.1.71:10068/uploadFile'
        // this.editor.create()
        this.editor.config.uploadImgShowBase64 = true // 使用 base64 保存图片
        // 隐藏“网络图片”tab
        this.editor.config.showLinkImg = false
        // 创建编辑器
        this.editor.create()

        //      this.editor.txt.html()
    }

    /*邮箱校验规则*/
    validateEmail(email) {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return emailRegex.test(email);
    }

    // 保存
    doSave() {
        let flag = true;
        // this.formModel.content = this.editor.txt.html();
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return;
            }
        })
        /*  去掉空值*/
        this.formModel.attachmentList = this.formModel.attachmentList.filter(item => item)
        if (this.formModel.recipient) {
            const emailarr = this.formModel.recipient.split(',')
            /*校验数组的每一项是否符合规则*/
            if (emailarr.some(item => !this.validateEmail(item))) {
                this.$message.error('抄送人邮箱格式不正确')
                flag = false
                return
            }
        }
        if (this.formModel.secret) {
            const emailarr1 = this.formModel.secret.split(',')
            if (emailarr1.some(item => !this.validateEmail(item))) {
                this.$message.error('密送人邮箱格式不正确')
                flag = false
                return
            }
        }
        if (this.formModel.customerEmail) {
            if (!this.validateEmail(this.formModel.customerEmail)) {
                this.$message.error('收件人邮箱格式不正确')
                flag = false
                return
            }
        }

        if (!this.editor.txt.html()) {
            this.$message.error('请填写正文')
            return
        }
        if (!this.formModel.attachmentList.length) {
            this.$message.error('请上传附件')
            return
        }

        if (!flag) {
            return
        } else {
            this.disabledBtn = true
        }

        const obj: any = {
            classesId: Number(this.classId),
            financeOrderId: Number(this.financeOrderId),
            subjectStr: this.formModel.title,
            contentStr: this.editor.txt.html(),
            ccStr: this.formModel.recipient,
            bccStr: this.formModel.secret,
            attachmentList: this.formModel.attachmentList.map(item => {
                return {
                    fileName: item.name,
                    filePath: item.url,
                }
            }),
            isFinish: this.formModel.isFinish,
            emailUser: this.formModel.emailUser,
            customerEmail: this.formModel.customerEmail,
        }
        setOutputTemplate(obj).then((res: any) => {
            this.$message.success('保存成功')
            this.disabledBtn = false
            setTimeout(() => {
                window.close()
            }, 500)
        }).catch(() => {
            this.disabledBtn = false
        })
    }


    /*发送*/
    async doSaveAndSend() {
        const idList: any = [this.financeOrderId]
        /*保存*/
        // this.formModel.content = this.editor.txt.html();
        let flag = true;
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return;
            }
        })
        /*  去掉空值*/
        this.formModel.attachmentList = this.formModel.attachmentList.filter(item => item)
        if (this.formModel.recipient) {
            const emailarr = this.formModel.recipient.split(',')
            /*校验数组的每一项是否符合规则*/
            if (emailarr.some(item => !this.validateEmail(item))) {
                this.$message.error('抄送人邮箱格式不正确')
                flag = false
                return
            }
        }
        if (this.formModel.secret) {
            const emailarr1 = this.formModel.secret.split(',')
            if (emailarr1.some(item => !this.validateEmail(item))) {
                this.$message.error('密送人邮箱格式不正确')
                flag = false
                return
            }
        }

        if (this.formModel.customerEmail) {
            if (!this.validateEmail(this.formModel.customerEmail)) {
                this.$message.error('收件人邮箱格式不正确')
                flag = false
                return
            }
        }

        if (!this.editor.txt.html()) {
            this.$message.error('请填写正文')
            return
        }
        if (!this.formModel.attachmentList.length) {
            this.$message.error('请上传附件')
            return
        }

        if (!flag) {
            return
        } else {
            this.disabledBtn = true
        }

        const obj: any = {
            classesId: Number(this.classId),
            financeOrderId: Number(this.financeOrderId),
            subjectStr: this.formModel.title,
            contentStr: this.editor.txt.html(),
            ccStr: this.formModel.recipient,
            bccStr: this.formModel.secret,
            attachmentList: this.formModel.attachmentList.map(item => {
                return {
                    fileName: item.name,
                    filePath: item.url,
                }
            }),
            isFinish: this.formModel.isFinish,
            emailUser: this.formModel.emailUser,
            customerEmail: this.formModel.customerEmail,
        }
        await setOutputTemplate(obj).then((res => {
            /*发送*/
            sendOutput(String(this.classId), {
                financeOrderIdList: idList,
            }).then((res: any) => {
                this.$message.success('发送成功')
                this.disabledBtn = false
                setTimeout(() => {
                    window.close()
                }, 500)
            }).catch(() => {
                this.disabledBtn = false
            })
        })).catch(err => {
            this.disabledBtn = false
        })

    }

    changeTemplate(val) {
        this.outputTemplateList.forEach((item, index) => {
            if (item.name == val) {
                this.formModel.recipient = this.outputTemplateList[index].ccStr
                this.formModel.secret = this.outputTemplateList[index].bccStr
                this.formModel.title = this.outputTemplateList[index].subjectStr
                this.editor.txt.html(this.outputTemplateList[index].contentStr)
                this.formModel.emailUser = item.emailUser
            }
        })
    }

    handleUploadSuccess(res, file, fileList) {
        /*等待所有请求都返回数据*/
        this.formModel.attachmentList = fileList.map(item => {
                /*如果item的status为success 则添加到数组*/
                if (item.status == 'success') {
                    return {
                        name: item.name,
                        url: item.url ? item.url : item.response.data.ossUrl
                    }
                }
            }
        )
    }

    handleUploadError() {
        this.$message.error('上传失败')
    }

    handleUploadRemove(file, fileList) {
        this.formModel.attachmentList = fileList
    }


    /*编辑相关*/

    // 详情
    getOutputRecordInfoById() {
        getOutputRecordInfoById(this.recordId).then((res: any) => {
            const data = JSON.parse(JSON.stringify(res.studentOutput))
            this.$set(this.formModel, 'secret', data.bccStr)
            this.$set(this.formModel, 'recipient', data.ccStr)
            this.$set(this.formModel, 'title', data.subjectStr)
            this.$set(this.formModel, 'emailUser', data.emailUser)
            this.$set(this.formModel, 'isFinish', data.isFinish)
            this.$set(this.formModel, 'customerEmail', data.customerEmail)
            this.editor.txt.html(data.contentStr)
            // this.$set(this.formModel, 'attachmentList', data.attachmentsList)
            this.formModel.attachmentList = data.attachmentsList.map(item => {
                return {
                    name: item.fileName,
                    url: item.filePath,
                }
            })
        })
    }

    /*编辑保存*/
    doEditSave() {
        let flag = true;
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return;
            }
        })
        /*  去掉空值*/
        this.formModel.attachmentList = this.formModel.attachmentList.filter(item => item)
        if (!this.editor.txt.html()) {
            this.$message.error('请填写正文')
            return
        }
        if (!this.formModel.attachmentList.length) {
            this.$message.error('请上传附件')
            return
        }
        if (this.formModel.recipient) {
            const emailarr = this.formModel.recipient.split(',')
            /*校验数组的每一项是否符合规则*/
            if (emailarr.some(item => !this.validateEmail(item))) {
                this.$message.error('抄送人邮箱格式不正确')
                flag = false
                return
            }
        }
        if (this.formModel.secret) {
            const emailarr1 = this.formModel.secret.split(',')
            if (emailarr1.some(item => !this.validateEmail(item))) {
                this.$message.error('密送人邮箱格式不正确')
                flag = false
                return
            }
        }

        if (this.formModel.customerEmail) {
            if (!this.validateEmail(this.formModel.customerEmail)) {
                this.$message.error('收件人邮箱格式不正确')
                flag = false
                return
            }
        }

        if (!flag) {
            return
        } else {
            this.disabledBtn = true
        }
        const obj: any = {
            subjectStr: this.formModel.title,
            contentStr: this.editor.txt.html(),
            ccStr: this.formModel.recipient,
            bccStr: this.formModel.secret,
            attachmentList: this.formModel.attachmentList.map(item => {
                return {
                    fileName: item.name,
                    filePath: item.url,
                }
            }),
            isFinish: this.formModel.isFinish,
            customerEmail: this.formModel.customerEmail,
        }
        updateOutputRecord(this.recordId, obj).then((res: any) => {
            this.$message.success('编辑保存成功')
            setTimeout(() => {
                window.close()
            }, 500)
        })
    }

    async doEditSaveAndSend() {

        let flag = true;
        (this.$refs.dynamicValidateForm as HTMLFormElement).validate((valid: boolean) => {
            if (!valid) {
                flag = false
                return;
            }
        })
        /*  去掉空值*/
        this.formModel.attachmentList = this.formModel.attachmentList.filter(item => item)
        if (!this.editor.txt.html()) {
            this.$message.error('请填写正文')
            return
        }
        if (!this.formModel.attachmentList.length) {
            this.$message.error('请上传附件')
            return
        }
        if (this.formModel.recipient) {
            const emailarr = this.formModel.recipient.split(',')
            /*校验数组的每一项是否符合规则*/
            if (emailarr.some(item => !this.validateEmail(item))) {
                this.$message.error('抄送人邮箱格式不正确')
                flag = false
                return
            }
        }
        if (this.formModel.secret) {
            const emailarr1 = this.formModel.secret.split(',')
            if (emailarr1.some(item => !this.validateEmail(item))) {
                this.$message.error('密送人邮箱格式不正确')
                flag = false
                return
            }
        }
        if (this.formModel.customerEmail) {
            if (!this.validateEmail(this.formModel.customerEmail)) {
                this.$message.error('收件人邮箱格式不正确')
                flag = false
                return
            }
        }

        if (!flag) {
            return
        } else {
            this.disabledBtn = true
        }
        const obj: any = {
            subjectStr: this.formModel.title,
            contentStr: this.editor.txt.html(),
            ccStr: this.formModel.recipient,
            bccStr: this.formModel.secret,
            attachmentList: this.formModel.attachmentList.map(item => {
                return {
                    fileName: item.name,
                    filePath: item.url,
                }
            }),
            isFinish: this.formModel.isFinish,
            customerEmail: this.formModel.customerEmail,
        }
        /*编辑保存*/
        await updateOutputRecord(this.recordId, obj).catch(err => {
            this.disabledBtn = false
        })
        /*编辑发送*/
        await sendOutputRecord(this.recordId).then((res: any) => {
            this.$message({
                message: '发送成功',
                type: 'success'
            })
            setTimeout(() => {
                window.close()
            }, 500)
        }).catch(err => {
            this.disabledBtn = false
        })
    }

    // 新建编辑去发送
    oepnEditproduce() {
        this.dialogVisible = true
    }

    confirmSendProduce() {
        if (this.recordId) {
            this.doEditSaveAndSend()
            this.dialogVisible = false
        } else {
            this.doSaveAndSend()
            this.dialogVisible = false
        }
    }

    doCancel(){
        this.dialogVisibletem = false
        /*关闭当前页面*/
        setTimeout(() => {
            window.close()
        }, 500)
    }
    doConfirm(){
        this.dialogVisibletem = false
        /*打开新建产出模板*/
        const win = window.open(window.location.origin + this.$route.matched[0].path + '/ProduceMouldAdd', "_blank")
        const time = setInterval(() => {
            if (win.closed) {
                clearInterval(time)
            }
        }, 500)
    }
}
